import { useContext, useState, useEffect, FC } from "react";
import { AuthContext } from "common/context/Auth";
import { IoFlagSharp } from "react-icons/io5";
import { Flag } from "./CommentActions.styled";
import Axios from "axios";
import { PublicationContext } from "common/context/Publication";
import { publicationTypes } from "common/context/Publication/PublicationContext";

interface Props {
  comment: {
    body: string;
    author: string;
    timestamp: number;
    id: string;
    flag?: string;
    users?: string[];
    authorEmail?: string;
    articleUrl?: string;
  };
}

const CommentActions: FC<Props> = ({ comment }) => {
  const { timestamp, id } = comment;
  const { session } = useContext<any>(AuthContext);
  const { publication, config } =
    useContext<publicationTypes>(PublicationContext);
  const [flagged, setFlagged] = useState<any>(comment?.users);

  useEffect(() => {
    setFlagged(comment?.users);
  }, [comment?.users]);

  const flag = async () => {
    try {
      const flag = {
        timestamp,
        flag: publication,
        id,
        users: comment?.users
          ? [...comment?.users, session?.username]
          : [session?.username],
      };
      await Axios.post(`/api/comment/flag`, flag);
      await Axios.post(`/api/ses`, {
        from: config.your_story,
        to: config.your_story,
        body: `<body><h1>A user has flagged a comment: ${
          config.pub
        }</h1><br/><p>Comment information:</p><p>name:${
          comment.author
        }</p><p>email: ${comment?.authorEmail}</p> <a href="${
          config.url + comment?.articleUrl
        }">${
          config.url + comment?.articleUrl
        }</a><br/><br/><p>Story:</p></body> `,
        subject: `new story for ${config.pub}`,
      });
      if (flagged) {
        setFlagged([...flagged, session?.username]);
      } else {
        setFlagged([session?.username]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  if (!session) {
    return null;
    //<>you have to log in to report comments</>;
  }

  if (comment.users && comment.users.length > 3) {
    return <Flag>Flagged</Flag>;
  }

  if (flagged && flagged.includes(session?.username)) {
    return <Flag>You have already flagged this comment</Flag>;
  }

  return (
    <Flag onClick={() => flag()}>
      Report comment
      <IoFlagSharp />
    </Flag>
  );
};
export default CommentActions;
